import { render, staticRenderFns } from "./ShowEditorDescription.vue?vue&type=template&id=535245d4"
import script from "./ShowEditorDescription.vue?vue&type=script&lang=js"
export * from "./ShowEditorDescription.vue?vue&type=script&lang=js"
import style0 from "./ShowEditorDescription.vue?vue&type=style&index=0&id=535245d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports